import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { RoomCategory } from 'app/typings';
import { apiRequest } from 'app/utils/request/api';

const path = '/rooms/categories' as const;

export function useRoomCategories() {
  return useQuery({
    queryKey: [path],
    queryFn: () => apiRequest({ path }) as Promise<RoomCategory[]>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
  });
}
